import FilterAltOutlinedIcon from "@mui/icons-material/FilterAltOutlined";
import { Box, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import dayjs from "dayjs";
import { Toolbar } from "../toolbar/toolbar.component";
import { Action } from "../../../types/toolbar";
import { serviceActionsSectionStyle } from "../../../styles/commonStyles";
import { useDateRangeQueryParams } from "../../../hooks/useDateRangeQueryParams";

const PRESET_MONTHS = [3, 6, 12];

export const DateRangeQuickFilters = () => {
  const { t } = useTranslation();
  const { dateRange, setDateRange } = useDateRangeQueryParams();

  const applyPreset = (months: number | null) => {
    if (months === null) {
      setDateRange({ start_date: null, end_date: null });
      return;
    }
    setDateRange({
      start_date: dayjs().subtract(months, "month").format("YYYY-MM-DD"),
      end_date: dayjs().format("YYYY-MM-DD"),
    });
  };

  const isAllTime = !dateRange.start_date && !dateRange.end_date;

  const quickFilterActions: Action[] = [
    {
      icon: <FilterAltOutlinedIcon />,
      label: t("All Time"),
      onClick: () => applyPreset(null),
      color: isAllTime ? "var(--primaryColor)" : undefined,
    },
    ...PRESET_MONTHS.map((months) => {
      const expectedStart = dayjs().subtract(months, "month").format("YYYY-MM-DD");
      const expectedEnd = dayjs().format("YYYY-MM-DD");
      const isActive =
        dateRange.start_date === expectedStart && dateRange.end_date === expectedEnd;

      return {
        icon: <FilterAltOutlinedIcon />,
        label: t(`Last ${months} Months`),
        onClick: () => applyPreset(months),
        color: isActive ? "var(--primaryColor)" : undefined,
      };
    }),
  ];

  return (
    <Box component="fieldset" sx={serviceActionsSectionStyle}>
      <Typography component="legend" variant="subtitle2" sx={{ px: 1, mb: 1 }}>
        {t("Quick filters")}
      </Typography>
      <Toolbar actions={quickFilterActions} noTopPadding showShortcut={false} />
    </Box>
  );
};
